import { render, staticRenderFns } from "./PublicCoupon.vue?vue&type=template&id=23032b45&scoped=true&"
import script from "./PublicCoupon.vue?vue&type=script&lang=js&"
export * from "./PublicCoupon.vue?vue&type=script&lang=js&"
import style0 from "./PublicCoupon.vue?vue&type=style&index=0&id=23032b45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23032b45",
  null
  
)

export default component.exports